module.exports = __webpack_public_path__ + "static/media/br.c834cb5b.svg";